import { type Aspect, ASPECTS } from "~/lib/api";
import { cn } from "~/lib/utils";
import { PillSelector } from "~/components/ui/pill-selector";

interface AspectSelectorProps {
  value: Aspect[] | null | undefined;
  onChange: (value: Aspect[] | null) => void;
  disabled?: boolean;
  className?: string;
}

export function AspectSelector({ value, onChange, disabled, className }: AspectSelectorProps) {
  const handleChange = (newValue: Aspect[] | null) => {
    if (!newValue || newValue.length === 0) {
      onChange(null);
      return;
    }
    const sorted = ASPECTS.filter((a) => newValue.includes(a));
    onChange(sorted);
  };

  return (
    <PillSelector.Root
      value={value ?? null}
      onChange={handleChange}
      multi
      label="Slope aspect"
      disabled={disabled}
      className={cn("gap-1.5", className)}
    >
      {ASPECTS.map((aspect) => (
        <PillSelector.Option key={aspect} value={aspect}>
          {aspect}
        </PillSelector.Option>
      ))}
    </PillSelector.Root>
  );
}
